<template>
    <div class="flex flex-wrap">
        <!-- <div class="w-50 mb-2 leading-tight" v-for="(field, index) in custom_fields"> -->
            <div class="mb-2 ml-2 leading-tight w-full row" v-for="(field, index) in custom_fields">
                <label v-if="!field.is_dead_reason_field" class="text-grey-darkest text-sm w-1/2 md:w-1/3"
                       :class="{'text-red' : customForm.errors ? customForm.errors.has(field.label_value) : ''}"
                        for="contract_type_id">{{field.label_value}}</label>
                <div v-if="field.options.length == 0 && field.type != 4" class="w-1/2 md:w-2/3">
                    <div class="flex">
                        <input @focusout="customFieldPop();pushToVista(field)" type="text" :name="field.name" :id="field.name.replace(/\s+/g, '-') + '-' + field.id" v-model="form[field.id]" @input="resetValidationErrors(field.label_value)"
                                :class="[({'border-red' : customForm.errors ? customForm.errors.has(field.label_value) : ''}), (field.is_project_custom_id && field.is_foundation_id_auto_generated && foundationAutoGeneratedAccess) , ((vistaJobNumberId && vistaJobNumberId == field.id && !editingVistaCustomField) || isSage100CustomNumberField(field.id) || (spectrumJobNumberCustomFieldId && spectrumJobNumberCustomFieldId == field.id && !editingVistaCustomField) || (isSage300CustomNumberField(field.id)) || (foundationJobNumberCustomFieldId && foundationJobNumberCustomFieldId == field.id) || (customFieldIds.includes(field.id)) || isSpectrumJobNumberField(field) ) ? 'bg-grey' : 'bg-white']"
                                class="appearance-none p-1 border-1 focus:outline-none rounded text-grey-darkest text-sm w-full field-height-update"
                                :disabled="customFieldIds.includes(field.id) || isFoundationAutoGeneratedJobNoFieldDisabled(field) || (vistaJobNumberId && vistaJobNumberId == field.id && !editingVistaCustomField) || isSage100CustomNumberField(field.id) || (spectrumJobNumberCustomFieldId && spectrumJobNumberCustomFieldId == field.id && !editingVistaCustomField) || isSage300CustomNumberField(field.id) || (foundationJobNumberCustomFieldId && foundationJobNumberCustomFieldId == field.id && !editingVistaCustomField) || isSpectrumJobNumberField(field)">
                        <span v-if="((vistaJobNumberId && vistaJobNumberId == field.id) || (spectrumJobNumberCustomFieldId && spectrumJobNumberCustomFieldId == field.id) || isSage100CustomNumberField(field.id) || (isSage300CustomNumberField(field.id)) || (foundationJobNumberCustomFieldId && foundationJobNumberCustomFieldId == field.id)) && !editingVistaCustomField" class="ml-2 cursor-pointer" @click.prevent="openVistaModal('jobNumberChangeConfirmModal')">
                            <i class="fa fa-pencil"></i>
                        </span>
                    </div>
                    <div class="text-red text-xs" v-if="customForm.errors && customForm.errors.has(field.label_value)">{{
                            customForm.errors ? customForm.errors.get(field.label_value) : '' }}
                     </div>
                    <div class="text-red text-xs" v-if="(!customForm.errors || !customForm.errors.has(field.label_value)) && customErrors && customErrors.hasOwnProperty(field.id)">
                        {{ customErrors ? customErrors[field.id] : '' }}
                    </div>
                </div>
                <div v-if="field.options.length == 0 && field.type == 4" class="w-1/2 md:w-2/3">
                    <datepicker @focusout="customFieldPop()" :name="field.name" :id="field.name.replace(/\s+/g, '-') + '-' + field.id" v-model="form[field.id]" :format="masks.date_mask" :use-utc="true"
                                @keypress.enter.prevent="this.closeCalendar()"
                                :input-class="[('cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'), (customForm.errors && customForm.errors.has(field.label_value) ? 'border-red' : '')]"
                                @input="resetValidationErrors(field.label_value)"></datepicker>
                    <div class="text-red text-xs" v-if="customForm.errors && customForm.errors.has(field.label_value)">{{
                            customForm.errors ? customForm.errors.get(field.label_value) : '' }}
                    </div>
                </div>
                <div v-if="field.options.length > 0 && !field.is_dead_reason_field" class="w-1/2 md:w-2/3">
                    <select @focusout="customFieldPop()" :name="field.name" :id="field.name.replace(/\s+/g, '-') + '-' + field.id" @change="resetValidationErrors(field.label_value)"
                            v-model="form[field.id]"
                            :class="{'border-red' : customForm.errors ? customForm.errors.has(field.label_value) : ''}"
                            class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-full field-height-update">
                        <option value="0">{{ team && customOptionTeamIds.includes(team.id) ? '' : '-' }}</option>
                        <option v-for="option in field.options" :value="option.id"> {{option.name}}</option>
                    </select>
                     <div class="text-red text-xs" v-if="customForm.errors && customForm.errors.has(field.label_value)">{{
                             customForm.errors ? customForm.errors.get(field.label_value) : ''}}
                     </div>
                </div>
            </div>

        <div class="modal" tabindex="-1" role="dialog" id="jobNumberChangeConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">Are you sure you want to edit the {{ currentErpName() }} Job Number</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Changing the Job # will create a new job on {{ currentErpName() }} or link this project with another Job on {{ currentErpName() }} that matches the new Job # entered.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('jobNumberChangeConfirmModal')">Cancel</button>
                        <button type="button" class="btn btn-danger" @click.prevent="editVistaCustomField()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="wrongMappingDirection" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">Error: The direction is not correct.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="text-danger">Error: The mapping direction is from {{ currentErpName() }} to Followup. Try changing the direction in settings.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeVistaModal('wrongMappingDirection')">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </div>
</template>

<script>
import Form from "../../../utils/form";
import Datepicker from 'vuejs-datepicker';

export default {
    props: ['project','agaveErp', 'customFieldErrors','masks', 'status', 'selects', 'salesStatusId', 'foundationContactSyncAccess', 'foundationAutoGeneratedJobNo', 'foundationAutoGeneratedAccess', 'vistaJobNumberCustomFieldId', 'vistaAccess', 'sageJobNumberCustomFieldId','sageAccess', 'sageProjectMapping',
        'spectrumJobNumberCustomFieldId', 'spectrumAccess', 'spectrumProjectMapping','isSpectrumSetToAutoGenerate', 'foundationAccess', 'foundationJobNumberCustomFieldId', 'foundationProjectMapping', 'team'],
    components: {Datepicker},
    data() {
        return {
            custom_fields: {},
            form: null,
            project_id : this.project_id ? this.project_id : '',
            customForm: new Form({}),
            isRequiredProjectManagerCustomField: false,
            foundationCustomIdField: null,
            customErrors: {},
            editingVistaCustomField: false,
            customFieldIds: [],
            customOptionTeamIds: [652, 558, 33, 217, 83, 512],
            vistaJobNumberId: null,
            vistaProjectDirection: null
        };
    },
    created() {
        this.fetchCustomFields();
    },
    mounted() {
        this.customForm.errors = this.customFieldErrors
        if(this.foundationProjectMapping){
            let fieldMappingList = JSON.parse(this.foundationProjectMapping.field_json);
            console.log('projectMapping', fieldMappingList);
            const customFieldList  =  fieldMappingList.fieldMappings.find(res => res.followUpLabel === "Auto-generated Job # based on foundationNew Job# (N/A to alphanumeric)")
            if(customFieldList.dropdownMappings.length>0){
                 this.customFieldIds = customFieldList.dropdownMappings.map(item => item.agave_field_id);
            }
            console.log('customFieldList', customFieldList);
        }

        if(this.vistaJobNumberCustomFieldId){
            this.vistaJobNumberId = this.vistaJobNumberCustomFieldId
        }

        Bus.$on('vistaCustomJobNumberIdChanged', data =>{
            this.vistaJobNumberId = data.vistaJobNumber
            this.vistaProjectDirection = data.direction
        })
    },
    computed: {
        sage300Access() {
            return !!(this.agaveErp && this.agaveErp.third_party_name == 'sage-300-cre');
        },
    },
    watch: {
        'customFieldErrors': function (oldVal, newVal) {
          console.log("new val", newVal)
        },
        'form': {
            handler(newValue, oldValue) {
                this.validateProjectManagerCustomField();
                this.validateFoundationJobNumber(newValue);
            },
            deep: true
        }
    },
    methods: {
        isAutoGeneratedCustomFields(field){

        },
        customFieldPop(){
            this.$emit('change-custom-field', true);
        },
        fetchCustomFields(){
            let self = this;
            axios.get(route('api.project-custom-field.index') + '?project=true').then(({data}) => {
                self.custom_fields = data.data.sort((a,b) => a.label_order - b.label_order);
                let  custom = [];
                for (let field in self.custom_fields) {
                    custom[self.custom_fields[field].id] = '';
                    if(self.custom_fields[field].is_project_custom_id) {
                        self.foundationCustomIdField = self.custom_fields[field];
                    }
                }
                custom['project_id'] = '';
                custom['status'] = '';
                custom['userTimezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
                custom['foundationStatus'] = null;
                custom['oldProjectContact'] = null;
                custom['oldProject'] = null;
                custom['oldProjectCustomFieldValues'] = null;
                custom['oldProjectSalesBehaviors'] = null;
                custom['newProjectSalesBehaviors'] = null;
                custom['oldRecordDetailCustomFieldValues'] = null;

                self.form = new Form(custom);
                if (self.project) {
                    self.fetchCustomvalues();
                }

            });
        },

        fetchCustomvalues(){
            let self = this;
            axios.get(route('api.project-custom-field-value.index') + `?project_id=${this.project.id}`).then(({data}) => {
                data.data.forEach(field => {
                    self.form[field.project_custom_field_id] = field.value;
                });
            });
        },

        submit(project_id, data = null, foundationStatus = null) {
            let self = this;
            this.form.project_id = project_id;
            this.form.status = this.status;
            this.form.foundationStatus = foundationStatus;
            this.form.oldProject = (data && data.oldProject) ? data.oldProject : {};
            this.form.oldProjectContact = (data && data.oldProjectContact) ? data.oldProjectContact: {};
            this.form.oldProjectCustomFieldValues = (data && data.oldProjectCustomFieldValues) ? data.oldProjectCustomFieldValues : [];
            this.form.oldProjectSalesBehaviors = (data && data.oldProjectSalesBehaviors) ? data.oldProjectSalesBehaviors: [];
            this.form.newProjectSalesBehaviors = (data && data.newProjectSalesBehaviors) ? data.newProjectSalesBehaviors: [];
            this.form.oldRecordDetailCustomFieldValues = (data && data.oldRecordDetailCustomFieldValues) ? data.oldRecordDetailCustomFieldValues: [];
            this.form.post(route('api.project-custom-field-value.store')).then((response) => {
                self.$emit('custom-field-response', data, response);
            }).catch((error) => {
                self.$emit('custom-field-response', data, null);
            });
        },

        resetValidationErrors(field) {
            if(field && this.customForm.errors.errors[field]) {
                delete this.customForm.errors.errors[field];
            }
        },

        getCustomFieldForm() {
            return this.form;
        },
        validateProjectManagerCustomField(foundationStatus) {
            let self = this;
            self.isRequiredProjectManagerCustomField = false;
            let customField = _.find(self.custom_fields, function(field) { return (field.is_foundation_project_manager === 1 && field.enabled === 1); });
            let salesStatus = self.getSalesStatus(self.salesStatusId);

            if(salesStatus !== null && salesStatus !== undefined && salesStatus.contract === 1 && foundationStatus !== 'sync') {
                if(customField !== null && customField !== undefined) {
                    if(this.form[customField.id] === undefined || this.form[customField.id] === null || this.form[customField.id] === "" || this.form[customField.id] === "0" || this.form[customField.id] === 0) {
                        this.isRequiredProjectManagerCustomField = true;
                    }
                }
            }
        },
        getSalesStatus(salesStatusId) {
            const self = this;
            if(self.selects && self.selects.hasOwnProperty('sales_status') && self.selects.sales_status !== null && self.selects.sales_status !== undefined) {
                return _.find(self.selects.sales_status, function (sale_status) {
                    return sale_status.id === salesStatusId;
                });
            }
        },
        validateFoundationJobNumber(customFieldForm) {
            let self = this;
            Object.keys(customFieldForm).forEach((key) => {
                if(self.foundationCustomIdField && self.foundationCustomIdField.hasOwnProperty('id') && key == self.foundationCustomIdField.id) {
                    if((self.form[key]).length > 10) {
                        self.form[key] = customFieldForm[key].slice(0, 10);
                        self.getToast(2000).fire({
                            type: 'error',
                            title: 'Job ID cannot exceed 10 characters'
                        });
                    }
                }
            });
        },
        isFoundationAutoGeneratedJobNoFieldDisabled(field) {
            console.log('field', field);
            return !!(field.is_project_custom_id && field.is_foundation_id_auto_generated && this.foundationAutoGeneratedAccess);
        },
        editVistaCustomField(){
            this.editingVistaCustomField = !this.editingVistaCustomField;
            this.closeVistaModal('jobNumberChangeConfirmModal');
        },
        pushToVista(field){
            if(this.form[field.id] && (this.vistaAccess || this.spectrumAccess || this.sage300Access || this.foundationAccess || this.sageAccess)){
                const existingFieldValue = this.project.custom_fields.find(item => item.project_custom_field_id == field.id);
                let customJobNumberFieldId = this.getSafe(() => this.agaveErp.project_field.custom_job_field.follow_up_field);
                this.editingVistaCustomField = false;
                if(!existingFieldValue || (existingFieldValue.value !== undefined && this.form[field.id] !== existingFieldValue.value)){
                    if ((this.vistaJobNumberId && this.vistaJobNumberId == field.id) || (this.sageJobNumberCustomFieldId && this.sageJobNumberCustomFieldId == field.id) || (this.spectrumJobNumberCustomFieldId && this.spectrumJobNumberCustomFieldId == field.id) || (customJobNumberFieldId && customJobNumberFieldId == field.id) || (this.foundationJobNumberCustomFieldId && this.foundationJobNumberCustomFieldId == field.id)){
                        if((this.vistaAccess && this.vistaProjectDirection && this.vistaProjectDirection == 'one-way-followup') || (this.spectrumAccess && this.spectrumProjectMapping && this.spectrumProjectMapping.direction == 'one-way-followup') || (this.sage300Access && this.getSafe(() => this.agaveErp.project_field.direction) == 'one-way-followup') || (this.sageAccess && this.getSafe(() => this.sageProjectMapping.direction) == 'one-way-followup')){
                            this.openVistaModal('wrongMappingDirection');
                        }else{
                            if(this.vistaAccess){
                                this.$emit('vista-job-number-changed', {jobNumber: this.form[field.id]});
                            }else if(this.spectrumAccess){
                                this.$emit('spectrum-job-number-changed', {jobNumber: this.form[field.id]});
                            }else if(this.sage300Access){
                                // this.$root.$emit('sage-300-job-number-changed', {jobNumber: this.form[field.id]});
                                this.$parent.$refs.Sage300Project.pushProject();    //calling sage300 project component method
                            }else if(this.sageAccess){
                                this.$parent.$refs.ProjectSageComponent.pushProjectToAgave();
                            }
                            else if(this.foundationAccess) {
                                this.$emit('foundationJobNumberChanged', {jobNumber: this.form[field.id]});
                            }
                        }
                    }

                }
            }
        },
        isSage300CustomNumberField(field_id) {
            let customJobNumberFieldId = this.getSafe(() => this.agaveErp.project_field.custom_job_field.follow_up_field);
            return  !!(this.sage300Access && !this.editingVistaCustomField && this.project && customJobNumberFieldId && customJobNumberFieldId == field_id)
        },
        isSage100CustomNumberField(field_id) {
            return  !!(this.sageAccess && !this.editingVistaCustomField && this.project && this.sageJobNumberCustomFieldId && this.sageJobNumberCustomFieldId == field_id)
        },
        isSpectrumJobNumberField(field) {
            return  !!(this.spectrumAccess && this.isSpectrumSetToAutoGenerate && field.show_spectrum_job_number == 1)
        },
        openVistaModal(modalId) {
            $('#'+modalId).modal('show');
        },
        closeVistaModal(modalId) {
            $('#'+modalId).modal('hide');
        },
        currentErpName() {
            if(this.spectrumAccess){
                return 'Spectrum';
            }else if(this.sage300Access){
                return 'Sage 300';
            }else if(this.sageAccess){
                return 'Sage 100';
			}else if(this.foundationAccess){
                return 'Foundation';
            }else{
                return 'Vista';
            }
        },
    },
}
</script>

<style scoped>
    .transparent-color {
        color: transparent !important;
    }
</style>
